import { render, staticRenderFns } from "./X-avancement-ordonnancement.vue?vue&type=template&id=2f4a315f&scoped=true"
import script from "./X-avancement-ordonnancement.vue?vue&type=script&lang=js"
export * from "./X-avancement-ordonnancement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4a315f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitnami/deploy/oscar_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f4a315f')) {
      api.createRecord('2f4a315f', component.options)
    } else {
      api.reload('2f4a315f', component.options)
    }
    module.hot.accept("./X-avancement-ordonnancement.vue?vue&type=template&id=2f4a315f&scoped=true", function () {
      api.rerender('2f4a315f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chantier/avancement/X-avancement-ordonnancement.vue"
export default component.exports